
<template>
    <v-container fluid>
        <v-layout  class="marT5" row>
            <v-flex xs12 sm12 md12 lg12>
                <v-card>                   
                    <v-flex xs12 sm12 md12 lg12>
                        <v-card-title class="headline light--cyan-bg" color="light-blue lighten-4" light>
                            <h4>Add Photo</h4>
                        </v-card-title>
                    </v-flex>
                    
                    <v-flex xs12 sm12 md12 lg12>
                        <v-card-text>
                            <v-flex
                            v-for="(card,index) in cards"
                            v-bind="{ [`xs${card.flex}`]: true }"
                            :key="index"
                            >
                            <v-card class="w150 mar10">
                                <div class="text-right marR20" @click="removeImg(card.title,card.imgId,index)">
                                <i class="material-icons clsIcon">close</i>
                                </div>
                                <div>
                                <v-img :src="card.src" height="150px" width="150px"></v-img>
                                </div>
                            </v-card>
                            </v-flex>
                            <v-flex xs2 v-if="(cards).length <= 0">
                                <v-card class="w150 mar10">
                                    <div class="divMidCnt">
                                    <div v-if="loader">
                                        <v-progress-circular
                                        :rotate="360"
                                        :size="100"
                                        :width="15"
                                        :value="imageUploadProgress"
                                        color="teal"
                                        >{{ imageUploadProgress }}</v-progress-circular>
                                    </div>

                                    <v-btn flat @click="launchFilePicker()" v-if="!loader">  
                                <i class="material-icons clsIcon">add</i>
                                </v-btn>
                                    </div>
                                    <input
                                    type="file"
                                    ref="file"
                                    :name="uploadFieldName"
                                    @change="onFileChange($event.target.name, $event.target.files)"
                                    class="disNone"
                                    >
                                </v-card>
                            </v-flex>
                        </v-card-text>
                    </v-flex>
                </v-card>
            </v-flex>
        </v-layout>

        <v-layout  class="marT5" row>
            <v-flex xs12 sm12 md12 lg12>
                <v-card>
                    <v-flex xs12 sm12 md12 lg12>
                        <v-card-title class="headline light--cyan-bg" color="light-blue lighten-4" light>
                            <h4>Create a New Event</h4>
                        </v-card-title>
                    </v-flex>
                    
                    <v-flex xs12 sm12 md12 lg12>
                        <v-card-text>
                            <form @submit.prevent="onCreateEvent">
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-text-field
                                            name="title"
                                            label="Title"
                                            id="title"
                                            v-model="eventModel.title"
                                            :rules="eventRules.title"
                                            required
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>

                                <v-layout row>
                                    <v-flex xs12>
                                        <v-text-field
                                            name="description"
                                            label="Description"
                                            id="description"
                                            v-model="eventModel.description"
                                            :rules="eventRules.description"
                                            multi-line
                                            rows="3"
                                            required
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap>
                                    <v-flex xs11 sm5></v-flex>
                                    <v-flex></v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs6 sm6 md6>
                                        <v-card-title class="headline light--cyan-bg" color="light-blue lighten-4" light>
                                            <h4>Event address</h4>
                                        </v-card-title>
                                    </v-flex>
                                    
                                    <v-flex xs6 sm6 md6>
                                        <v-card-title class="headline light--cyan-bg" color="light-blue lighten-4" light>
                                            <h4>Organizator contacts</h4>
                                        </v-card-title>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs6 sm6 md6 class="padR8">
                                        <v-text-field
                                            name="address1"
                                            label="Address"
                                            id="address1"
                                            v-model="eventModel.address1"
                                            :rules="eventRules.address1"
                                            required
                                        ></v-text-field>
                                        <v-text-field
                                            name="address2"
                                            label="Address 2"
                                            id="address2"
                                            v-model="eventModel.address2"
                                            :rules="eventRules.address2"
                                        ></v-text-field>
                                        <v-text-field
                                            name="city"
                                            label="City"
                                            id="city"
                                            v-model="eventModel.city"
                                            :rules="eventRules.city"
                                            required
                                        ></v-text-field>
                                        <v-text-field
                                            name="state"
                                            label="State"
                                            id="state"
                                            v-model="eventModel.state"
                                            :rules="eventRules.state"
                                            required
                                        ></v-text-field>
                                        <v-text-field
                                            name="zip"
                                            label="Zip"
                                            id="zip"
                                            v-model="eventModel.zip"
                                            :rules="eventRules.zip"
                                            required
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 sm6 md6 class="padL8">
                                        <v-text-field
                                            name="contactName"
                                            label="Name"
                                            id="contactName"
                                            v-model="eventModel.contactName"
                                            :rules="eventRules.contactName"
                                            required
                                        ></v-text-field>
                                        <v-text-field
                                            name="contactPhone"
                                            label="Phone"
                                            id="contactPhone"
                                            v-model="eventModel.contactPhone"
                                            :rules="eventRules.contactPhone"
                                        ></v-text-field>
                                        <v-text-field
                                            name="email"
                                            label="Email"
                                            id="email"
                                            v-model="eventModel.email"
                                            :rules="eventRules.email"
                                        ></v-text-field>
                                        <v-text-field
                                            name="website"
                                            label="Website"
                                            id="website"
                                            v-model="eventModel.website"
                                            :rules="eventRules.website"
                                        ></v-text-field>
                                        <v-text-field
                                            name="facebook"
                                            label="Facebook event Page"
                                            id="facebook"
                                            v-model="eventModel.facebook"
                                            :rules="eventRules.facebook"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout> 

                                <v-layout row>
                                    <v-flex xs12 sm12 md12>Event schedule</v-flex>
                                </v-layout>
                                <li v-for="(item, i) in eventModel.items" :key="i">
                                    <v-layout row>
                                        <v-flex xs3 sm3 md3>
                                            <v-menu
                                            ref="eventModel.items[i].menu1"
                                            :close-on-content-click="false"
                                            v-model="eventModel.items[i].menu1"
                                            :nudge-right="40"
                                            lazy
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            min-width="290px"
                                            >
                                            <v-text-field
                                                slot="activator"
                                                v-model="eventModel.items[i].date"
                                                label="Picker in menu"
                                                prepend-icon="event"
                                                readonly
                                            ></v-text-field>
                                            <v-date-picker
                                                v-model="eventModel.items[i].date"
                                                no-title
                                                scrollable
                                                @input="eventModel.items[i].menu1 = false"
                                            ></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex xs1 sm1 md1></v-flex>
                                        <v-flex xs2 sm2 md2>
                                            <v-select
                                            :items="items"
                                            label="Periodicity"
                                            v-model="eventModel.items[i].periodicity"
                                            ></v-select>
                                        </v-flex>

                                        <v-flex xs2 sm2 md2>
                                            <v-menu
                                            ref="eventModel.items[i].smenu"
                                            :close-on-content-click="false"
                                            v-model="eventModel.items[i].smenu"
                                            :nudge-right="40"
                                            lazy
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            max-width="290px"
                                            min-width="290px"
                                            >
                                            <v-text-field
                                                slot="activator"
                                                v-model="eventModel.items[i].startTime"
                                                label="Start time"
                                                prepend-icon="access_time"
                                                readonly
                                            ></v-text-field>
                                            <v-time-picker
                                                v-model="eventModel.items[i].startTime"
                                                scrollable
                                                full-width
                                                @input="eventModel.items[i].smenu = false"
                                            ></v-time-picker>
                                            </v-menu>
                                        </v-flex>

                                        <v-flex xs2 sm2 md2>
                                            <v-menu
                                            ref="eventModel.items[i].emenu"
                                            :close-on-content-click="false"
                                            v-model="eventModel.items[i].emenu"
                                            :nudge-right="40"
                                            lazy
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            max-width="290px"
                                            min-width="290px"
                                            >
                                            <v-text-field
                                                slot="activator"
                                                v-model="eventModel.items[i].endTime"
                                                label="End time"
                                                prepend-icon="access_time"
                                                readonly
                                            ></v-text-field>
                                            <v-time-picker
                                                v-model="eventModel.items[i].endTime"
                                                full-width
                                                @input="eventModel.items[i].emenu = false"
                                            ></v-time-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex xs2 sm2 md2 v-if="i">
                                        <div class="marTL18 pointer">
                                        <i class="material-icons" @click="removeDay(i)">close</i>
                                        </div>
                                    </v-flex>
                                    </v-layout>
                                </li>

                                <v-layout row>
                                    <v-flex xs12 sm12 md12 text-xs-left>
                                        <div>
                                            <v-btn flat @click="addDays()">+ ADD DAYS</v-btn>
                                        </div>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-btn class="primary" @click="onCreateEvent" :disabled="!formIsValid">Publish</v-btn>
                                        <v-btn class="primary" :disabled="true" type="submit">Save Draft</v-btn>
                                        <v-btn class="primary" :disabled="true" type="submit">Preview</v-btn>
                                    </v-flex>
                                </v-layout>
                            </form>
                        </v-card-text>
                    </v-flex>
                </v-card>
            </v-flex>
        </v-layout>
        <v-layout row>
            <v-flex xs12>
                
            </v-flex>

            <v-dialog v-model="dialog" max-width="290">
                <v-card>
                    <v-card-title class="headline">Really want to delete?</v-card-title>

                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn color="red darken-1" flat="flat" @click="dialog = false,removeData()">Yes</v-btn>

                        <v-btn color="green darken-1" flat="flat" @click="dialog = false">No</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-container>
</template>

<script>
    import EventService from "@/services/db/EventService.js";
    import CONSTANT from "@/services/Constant.js";

    import firebase from "firebase";
    import Utils from "@/services/Utils.js";

    export default {
        name: "Create-Event",
        props: ["id"],
        data() {
            return {
                eventModel: this.getDefaultEvent(),
                uploadFieldName: "file",
                maxSize: 1024,
                loader: false,
                rmType: "",
                dialog: false,
                rmImgId: "",
                addUpdateType: "",
                rmImgName: "",
                index: 0,
                imgId: false,
                timeStamp: "",
                imageName: "",
                imageUrl: "",
                imageFile: "",
                imageUploadProgress: 0,
                cards: [ ],
                items: ["week", "month", "year"],
                eventDateMenu: false,
                eventRules: {
                    title: [v => !!v || "Title is required"],
                    description: [v => !!v || "Description is required"],
                    address1: [v => !!v || "Address is required"],
                    city: [v => !!v || "City is required"],
                    state: [v => !!v || "State is required"],
                    zip: [v => !!v || "Zip is required"],
                    contactName: [v => !!v || "Name is required"],
                    contactPhone: [v => !!v || "Phone is required"],
                    facebook: [v => !!v || "Facebook event page is required"],
                    email: [
                        v => {
                            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                            return pattern.test(v) || "Invalid e-mail.";
                        }
                    ],
                    website: [v => !!v || "Website is required"]
                }
            };
        },
        created() {
            this.id = this.$route.params.id;

            if(this.id != undefined && this.id != "" && this.id != null){
                this.imgId = this.id;
                this.addUpdateType = "update";
                 this.loadEventById(this.id);
            } else {
                this.addUpdateType = "insert";
            }
        },
        computed: {
            // VALIDATE FORM VALUES
            formIsValid() {
                return (
                    this.eventModel.title !== "" &&
                    this.eventModel.description !== "" &&
                    this.eventModel.address1 !== "" &&
                    this.eventModel.city !== "" &&
                    this.eventModel.state !== "" &&
                    this.eventModel.zip !== "" &&
                    this.eventModel.contactName !== "" &&
                    this.eventModel.email !== "" && 
                    this.eventModel.website !== "" && 
                    Utils.isValidEmail(this.eventModel.email) && 
                    Utils.isValidURL(this.eventModel.website)
                );
            }, 

            // SET A DEFAULT DATE TIME FOR THE PICKERS
            // OR COMPUTE DATETIME BASED ON SELECTED VALUES FROM EACH PICKER
            submittableDateTime() {
                // PARSE DEFAULT DATED INTO DATE OBJECT
                const date = new Date(this.date);
                // DEBUG
                // console.log(date)
                // CHECK IF PICKER RETURNED A STRING OR DEFAULT DATE OBJECT IS USED
                if (typeof this.time === "string") {
                    const hours = this.time.match(/^(\d+)/)[1];
                    const minutes = this.time.match(/:(\d+)/)[1];
                    date.setHours(hours);
                    date.setMinutes(minutes);
                } else {
                    date.setHours(this.time.getHours());
                    date.setMinutes(this.time.getMinutes());
                }
                return date;
            }
        },
        methods: {
            getDefaultEvent() {
                return { 
                    title: "",
                    description: "",
                    address1: "",
                    address2: "",
                    city: "",
                    state: "",
                    zip: "",
                    contactName: "",
                    contactEmail: "",
                    contactPhone: "",
                    email: "",
                    facebook: "",
                    website: "",
                    items: [
                        {
                            date: "",
                            startTime: null,
                            endTime: null,
                            periodicity: "",
                            menu1: false,
                            emenu: false,
                            smenu: false
                        }
                    ]
                };
            },
            // Load event by id
            loadEventById(id){
                 EventService.getEventById(id, event => {
                    if (event) {
                        this.cards =  event['photos'];
                        this.eventModel = Object.assign({}, event);
                    }
                });
            },

            // launch file picker
            launchFilePicker() {
                this.$refs.file.click();
            },
            //file change
            onFileChanged() {
            },
            //after file select img img upload 
            onFileChange(fieldName, files) {
                var type = "image";
                if (files[0] !== undefined) {
                    this.loader = true;
                    var _name = files[0].name;
                    if (_name.lastIndexOf(".") <= 0) {
                        return;
                    }
                    const fr = new FileReader();
                    fr.readAsDataURL(files[0]);
                    fr.addEventListener("load", () => {
                        if (type == "image") {
                            this.imageName = _name;
                            this.imageFile = files[0];
                        }
                        this.uploadImage(type);
                    });
                }
            },
            // remove day
            removeDay(index) {
                this.index = index;
                this.dialog = true;
                this.rmType = "day";
            },
            // remove data
            removeData() {
                if (this.rmType == "day") {
                    this.eventModel.items.splice(this.index, 1);
                    this.index = 0;
                    this.rmType = "";
                } else if (this.rmType == "image") {
                    var imgReff = CONSTANT.FIREBASE_STORAGE.EVENTS + this.rmImgId + "/";
                    var storageRef = firebase.storage().ref(imgReff);
                    var desertRef = storageRef.child(this.rmImgName);

                    // Delete the file
                    desertRef
                    .delete()
                    .then(() => {
                        this.cards.splice(this.index, 1);
                        this.$store.commit("setAlert", {
                                isAlertSuccess: true,
                                message: CONSTANT.MESSAGES.EVENT.IMAGE_DELETE_SUCCESS
                        });
                        this.rmImgId = "";
                        this.rmImgName = "";
                        this.rmType = "";
                        this.onCreateEvent();
                    })
                    .catch(() => {
                        this.$store.commit("setAlert", {
                            isAlertSuccess: true,
                            message: CONSTANT.MESSAGES.EVENT.IMAGE_DELETE_FAIL
                        });
                    });
                }
            },
            //upload image
            uploadImage(type) {
                if (this.imageFile) {
                    var _name = this.imageName;
                    this.isUploadingImage = type == "image" ? true : false;

                    var imgReff = CONSTANT.FIREBASE_STORAGE.EVENTS;

                    this.timeStamp = Utils.getTimestampByDate();
                    if (this.imgId) {
                        imgReff = imgReff + this.imgId + "/" + this.timeStamp + _name;
                    } else {
                        this.imgId = Utils.generateUUID();
                        this.id = this.imgId;
                        imgReff = imgReff + this.imgId + "/" + this.timeStamp + _name;
                    }
                    var storageRef = firebase.storage().ref(imgReff);

                    var uploadTask = storageRef.put(this.imageFile);

                    uploadTask.on(
                    "state_changed",
                    snapshot => {
                        var progress = (
                        (snapshot.bytesTransferred / snapshot.totalBytes) *
                        100
                        ).toFixed(2);
                        this.imageUploadProgress = parseInt(type == "image" ? progress : 0);
                    }, () => {
                        this.$store.commit("setAlert", {
                            isAlertError: true,
                            message: this.id
                                ? CONSTANT.MESSAGES.EVENT.UPDATE_FAIL
                                : CONSTANT.MESSAGES.EVENT.UPLOAD_FAIL
                        });
                    }, () => {
                            // Upload complete
                            storageRef.getDownloadURL().then(url => {
                            this.$store.commit("setAlert", {
                                isAlertSuccess: true,
                                message: CONSTANT.MESSAGES.EVENT.IMAGE_UPLOAD_SUCCESS
                            });

                            this.cards.push({
                                title: this.timeStamp + this.imageName,
                                src: url,
                                imgId: this.imgId,
                                flex: 2
                            });
                            this.loader = false;
                            setTimeout(() => {
                                this.isUploadingImage = false;
                                 this.onCreateEvent();
                            }, 1000);
                            });
                        }
                    );
                }
            },

            // GRAB FORM VALUES, CHECK VALIDATION, ADD EVENT TO STORE
            onCreateEvent() {
                // VALIDATE FORM INPUT
                if (!this.formIsValid) {
                    return; // prevent invalid form submission
                }
                // EVENT IMAGE REQUIRED
                //   if (!this.rawImageFile) {
                //     return; // prevent submission if no file provided
                //   }
                // CREATE EVENT OBJECT
                // const eventData = {
                //     title: this.eventModel.title,
                //     summary: this.eventModel.summary,
                //     description: this.eventModel.description,
                //     location: this.eventModel.location,
                //     address1: this.eventModel.address1,
                //     address2: this.eventModel.address2,
                //     city: this.eventModel.city,
                //     state: this.eventModel.state,
                //     zip: this.eventModel.zip,
                //     contactName: this.eventModel.contactName,
                //     contactEmail: this.eventModel.contactEmail,
                //     contactPhone: this.eventModel.contactPhone,
                //     facebook: this.eventModel.facebook,
                //     website: this.eventModel.website,
                //     startDateTime: new Date(),
                //     photo: ""
                // };

                this.eventModel['photos'] = this.cards

                EventService.addEditEvent(this.eventModel, this.id,this.addUpdateType)
                    .then(UUID => {
                    this.id = UUID;
                        this.$store.commit("setAlert", {
                            isAlertSuccess: true,
                            message: (this.addUpdateType == "update")
                            ? CONSTANT.MESSAGES.EVENT.UPDATE_SUCCESS
                            : CONSTANT.MESSAGES.EVENT.ADD_SUCCESS
                        });
                          if(this.addUpdateType == 'insert'){
                              this.$router.push('/event/'+this.id);
                          }
                    })
                    .catch(() => {
                    this.$store.commit("setAlert", {
                            isAlertError: true,
                            message: this.id
                            ? CONSTANT.MESSAGES.EVENT.UPDATE_FAIL
                            : CONSTANT.MESSAGES.EVENT.ADD_FAIL
                        });
                    });
            },
            //goto events page
            onCancel() {
                // SHOW EVENTS LIST
                this.$router.push("/events");
            },
            // on file pick from local machine
            onPickFile() {
                // FIRE CLICK EVENT WHEN BUTTON IS CLICKED TO UPLOAD IMAGE
                this.$refs.fileInput.click();
            },
            // add new days 
            addDays() {
                this.eventModel.items.push({
                    date: "",
                    startTime: null,
                    endTime: null,
                    periodicity: "",
                    menu1: false
                });
            },
            // after file pick and upload image 
            onFilePicked(event) {
                // GET ALL FILES
                const files = event.target.files;
                // GET FIRST FILE IN ARRAY
                let filename = files[0].name;
                // BASIC VALIDATION OF IMAGE FILE
                if (filename.lastIndexOf(".") <= 0) {
                    return alert("Please upload a valid file!");
                }
                // CREATE FILE READER
                const fileReader = new FileReader();
                fileReader.addEventListener("load", () => {
                    this.imagePreview = fileReader.result; // base64 string
                });
                // READ FILE
                fileReader.readAsDataURL(files[0]);
                // GRAB RAW IMAGE FILE
                this.rawImageFile = files[0];
            },
            //remove image 
            removeImg(imgName, imgId, index) {
                this.index = index;
                this.rmImgId = imgId;
                this.rmImgName = imgName;
                this.dialog = true;
                this.rmType = "image";
            },
            // date formate
            parseMMDDYYDate(date) {
                return Utils.parseMMDDYYDate(date);
            }
        }
    };
</script>

<style>
       
li {
    list-style-type: none;
}

.divMidCnt {
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    width: 150px;
    height: 150px;
    min-height: 150px;
}

.clsIcon {
    position: absolute;
    color: white;
    z-index: 1;
    border: 1px solid;
    border-radius: 50%;
    top: -10px;
    cursor: pointer;
    background-color: #6882A5;
} 

.flex.xs2{
    flex-basis: 12.666667% !important;
}
</style>
